import React from "react";

import styles from "./Content.module.scss";

export default function Content({classname, children}) {
    return (
        <section className={[styles.Main, classname ?? ''].join(' ')}>
            { children }
        </section>
    )
}
